import {
  FORGOT_PASSWORD,
  HOME,
  LOGIN,
  PAGE401,
  RESET_PASSWORD,
  RESET_PASSWORD_CONFIRM,
} from "@constants/routes";
import ForgotPassword from "@pages/Account/ForgotPassword";
import ResetPassword from "@pages/Account/ResetPassword";
import ResetPasswordConfirmation from "@pages/Account/ResetPasswordConfimation";
import LogIn from "@pages/LogIn";
import NotAccess from "@pages/NotAccess401";
import NotFound404 from "@pages/NotFound404";
import { Route, Switch } from "react-router-dom";
import MainWrapper from "./MainWrapper";
import WrappedRoutes from "./WrappedRoutes";

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path={LOGIN} component={LogIn} />
        <Route exact path={FORGOT_PASSWORD} component={ForgotPassword} />
        <Route exact path={RESET_PASSWORD} component={ResetPassword} />
        <Route
          exact
          path={RESET_PASSWORD_CONFIRM}
          component={ResetPasswordConfirmation}
        />
        <Route exact path={PAGE401} component={NotAccess} />
        <Route path={HOME} component={WrappedRoutes} />
        <Route component={NotFound404} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
